<template>
      <div class="grid-x grid-padding-x contentContainer">
        <div class="cell small-8 medium-8 large-6 contentPositionTop align-left text-left">
          <h1>{{ name }}</h1>
          <span class="position">{{ position }}</span>

          <img style="max-height: 85px; "
               alt="Ailsa - Department of Education"
               v-if="id === 'Ailsa'" class="logoImg" src="@/assets/img/logos/home-page-logos/DepartmentEducation-white.png" />
          <img style="max-height: 31px; "
               alt="Daniel - BCG"
               v-if="id === 'Hamze'" class="logoImg" src="@/assets/img/logos/home-page-logos/BainCompany-white.png" />
          <img style="max-height: 20px; "
               alt="David - Allen & Overy"
               v-if="id === 'David'" class="logoImg" src="@/assets/img/logos/home-page-logos/a-o-shearman-white.png" />
          <img style="max-height: 60px; "
               alt="Leonie - Clifford Chance"
               v-if="id === 'Leonie'" class="logoImg" src="@/assets/img/logos/home-page-logos/CliffordChance-white.png" />
          <img style="max-height: 85px; "
               alt="Francesca - Clifford Chance"
               v-if="id === 'Francesca'" class="logoImg" src="@/assets/img/logos/home-page-logos/CliffordChance-white.png" />
          <img style="max-height: 60px; "
               alt="Roy - Clifford Chance"
               v-if="id === 'Roy'" class="logoImg" src="@/assets/img/logos/home-page-logos/CliffordChance-white.png" />
          <img style="max-height: 85px; "
               alt="Sengova - Hogan Lovells"
               v-if="id === 'Sengova'" class="logoImg" src="@/assets/img/logos/home-page-logos/HoganLovells.png" />
          <img style="max-height: 40px; "
               alt="Tony - Clyde & Co."
               v-if="id === 'Tony'" class="logoImg" src="@/assets/img/logos/home-page-logos/ClydeCo-white.png" />

        </div>
      </div>
</template>
<script>

export default {
  name: 'RareStoriesHeaderContents',
  props: {
    id: {
      type: String,
      required: false,
    },

    name: {
      type: String,
      required: false,
    },
    position: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .contentContainer {
    height: 100%;
  }

  h1 {
    color: #ffffff;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  .position {
    color: #ffffff;
    display: block;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }


  @media only screen and (max-width: 640px)  {
    .contentPositionTop {
      padding-left: 6%;
    }

    .position {
      font-size: 14px;
    }

    h1 {
      font-size: 28px;
      line-height: 1.33;
      margin-top: 24px;
      margin-left: 20;
    }

    .logoImg {
      position: absolute;
      bottom: 32px;
    }
  }

  @media only screen and (min-width: 641px) and (max-width: 1050px)  {
    .contentPositionTop {
      padding-left: 6%;
    }

    .position {
      font-size: 14px;
    }

    h1 {
      font-size: 36px;
      line-height: 1.33;
      margin-top: 24px;
      margin-left: 20;
    }

    .logoImg {
      position: absolute;
      bottom: 64px;
    }

  }


  @media only screen and (min-width: 1051px)  {
    .contentPositionTop {
      padding: 6.5% 0 0 16%;
    }

    .position {
      font-size: 21px;
      line-height: 1.52;
    }

    .logoImg {
      position: absolute;
      bottom: 99px;
      max-height: 85px;
    }

    h1 {
      font-size: 56px;
      line-height: 1.25;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/stories/components/RareStoriesHeaderContentsStory.vue